import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import style from "../../../../../../../assets/styles/componentStyles/carouselTemplateGroupStyles/carouselTemplateGroupStyle.module.scss";
import contactStyles from "../../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import globalStyles from "../../../../../../../assets/styles/global.module.scss"
import GlobalButton from '../../../../../../utility/globalButton/button'
import Required from '../../../../../../utility/required'
import { useShallow } from 'zustand/react/shallow'
import { useCarouselTemplateGroupStore } from '../../../../../../../store/carouselTemplateGroupStore'
import { carouselTemplateGroup, createCarouselTemplateGroupPayload, getTemplateDetails, updateCarouselTemplateGroupPayload } from '../../../../../../../models/axiosModel'
import { defaultCarouselTemplateGroupObj } from '../constants'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../../context/integrationContext'
import { UserContext, UserContextPayload } from '../../../../../../../context/userContext'
import { useSearchParams } from 'react-router-dom'
import agent from '../../../../../../../services/api'
import RefreshIcon from '@mui/icons-material/Refresh';
import GlobalTooltip from '../../../../../../utility/tooltip/globalTooltip';
import { useGenericStore } from '../../../../../../../store/genericStore';

interface CreateTemplateGroupPopupProps {
    getCarouselTemplateGroupsApi: (meta_integration_whatsapp_id: number) => Promise<void>
}

// type fieldValuesType = "templateGroupName" | "maxCardCount" | "templates";
type fieldValuesType = 
    | { type: "templateGroupName" }
    | { type: "maxCardCount" }
    | { type: "templates", cardCount: number }

type fieldUpdateType =
    | { type: "templateGroupName"; value: string }
    | { type: "maxCardCount"; value: number | string }
    | { type: "templates"; value: getTemplateDetails | null, cardCount: number }

const CreateTemplateGroupPopup: React.FC<CreateTemplateGroupPopupProps> = (props) => {

    const { getCarouselTemplateGroupsApi } = props;

    const [searchParams, setSearchParams] = useSearchParams();
    let id = searchParams.get("id");

    const { carouselTemplateList, setFlagCreateTemplateGroupPopup, selectedTemplateGroup, setSelectedTemplateGroup, getCarouselTemplateList, getWhatsappTemplateTypes, whatsAppTemplateTypes } = useCarouselTemplateGroupStore(
        useShallow((state) => ({
            carouselTemplateList: state.carouselTemplateList,
            setFlagCreateTemplateGroupPopup: state.setFlagCreateTemplateGroupPopup,
            setSelectedTemplateGroup: state.setSelectedTemplateGroup,
            selectedTemplateGroup: state.selectedTemplateGroup,
            getCarouselTemplateList: state.getCarouselTemplateList,
            getWhatsappTemplateTypes: state.getWhatsappTemplateTypes,
            whatsAppTemplateTypes: state.whatsAppTemplateTypes
        }))
    );
    const { globalIntegrationTypeList, integrationDetails } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [carouselTemplateGroup, setCarouselTemplateGroup] = useState<carouselTemplateGroup>(selectedTemplateGroup ? selectedTemplateGroup : defaultCarouselTemplateGroupObj)
    const innerHeight = window.innerHeight - 300;

    const getWhatsappTemplateTypesApi = async () => {
        const res = await getWhatsappTemplateTypes();
        if (!(res.status)) {
            handleError(res);
        }
    }

    const getWhatsAppCarouselTemplateListApi = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const carouselTemplateTypeId = whatsAppTemplateTypes?.find((type) => type?.name?.toLowerCase() === 'carousel')?.whatsapp_template_type_id;
        const res = await getCarouselTemplateList(integrationDetails?.meta_integration_whatsapp_id ?? 0, carouselTemplateTypeId ?? 0);
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        if (!whatsAppTemplateTypes) {
            getWhatsappTemplateTypesApi();
        }
    }, []);

    useEffect(() => {
        if (whatsAppTemplateTypes && !carouselTemplateList) {
            getWhatsAppCarouselTemplateListApi();
        }
    }, [whatsAppTemplateTypes])

    const getPopupTitle = () => {
        let title = 'Create Carousel Template Group';
        if (selectedTemplateGroup) {
            title = `Edit - ${selectedTemplateGroup?.carousel_template_group_name}`;
        }
        return title;
    }

    const filterTemplateByCardCount = (templateGroup: carouselTemplateGroup, cardCount: number) => {
        return templateGroup?.templates?.filter((template) => template?.card_count !== cardCount)
    }

    const getFieldValues = (valueType: fieldValuesType) => {
        const { type } = valueType;
        switch (type) {
            case 'templateGroupName':
                return carouselTemplateGroup?.carousel_template_group_name ?? '';
            case 'maxCardCount':
                const maxCardCount = carouselTemplateGroup?.max_card_count;
                if(maxCardCount === '' || maxCardCount === null || maxCardCount === undefined){
                    return ''
                } else {
                    return maxCardCount;
                }
            case 'templates':
                return carouselTemplateList?.filter((template) => carouselTemplateGroup?.templates?.some((templateGroup) => templateGroup?.whatsapp_template_id == template?.whatsapp_template_id))?.find((template) => template?.carousel_template_card_count == valueType?.cardCount) || null;
        }
    }

    const onChangeOfFields = (updateType: fieldUpdateType) => {
        const { type, value } = updateType;
        setCarouselTemplateGroup((prev: carouselTemplateGroup) => {
            let latestTemplateGroup = { ...prev };

            switch (type) {
                case 'templateGroupName':
                    latestTemplateGroup = {
                        ...latestTemplateGroup,
                        carousel_template_group_name: value,
                    }
                    break;
                case 'maxCardCount':
                    latestTemplateGroup = {
                        ...latestTemplateGroup,
                        max_card_count: value ? value : '',
                        templates: value ? latestTemplateGroup?.templates?.filter((template) => template?.card_count <= Number(value)) : latestTemplateGroup?.templates
                    }
                    break;
                case 'templates':
                    latestTemplateGroup = {
                        ...latestTemplateGroup,
                        templates: value ? [...(filterTemplateByCardCount(latestTemplateGroup, updateType?.cardCount)), {
                            wa_carousel_template_group_mapping_id: '',
                            card_count: value?.carousel_template_card_count,
                            whatsapp_template_id: value?.whatsapp_template_id,
                            template_details: null
                        }] : filterTemplateByCardCount(latestTemplateGroup, updateType?.cardCount)
                    }
                    break;
            }

            return latestTemplateGroup;
        })
    }

    const onClickOfCancel = () => {
        setFlagCreateTemplateGroupPopup(false);
        setSelectedTemplateGroup(null);
    }

    const checkDisableCreateBtn = () => {
        const maxCardCount = Number(carouselTemplateGroup?.max_card_count) || 0;
        const templates = carouselTemplateGroup?.templates ?? [];

        if (!carouselTemplateGroup?.carousel_template_group_name?.trim() || !maxCardCount || !templates?.length) {
            return true;
        }

        // Validate that user has selected templates from each card count 2 to selected maximum card count
        const selectedCardCounts = new Set(templates.map((t) => t?.card_count));
        for (let i = 2; i <= maxCardCount; i++) {
            if (!selectedCardCounts.has(i)) {
                return true;
            }
        }

        return false;
    }

    const onClickOfCreateBtn = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let res;
        if (!selectedTemplateGroup) {

            const payload: createCarouselTemplateGroupPayload = {
                channel_id: globalIntegrationTypeList?.find((integration) => integration?.channel_name?.toLowerCase() === 'whatsapp')?.channel_id ?? 1,
                carousel_template_group_name: carouselTemplateGroup?.carousel_template_group_name,
                max_card_count: Number(carouselTemplateGroup?.max_card_count),
                meta_integration_whatsapp_id: integrationDetails?.meta_integration_whatsapp_id ?? Number(id),
                templates: carouselTemplateGroup?.templates?.map((template) => {
                    return {
                        whatsapp_template_id: template?.whatsapp_template_id,
                        card_count: template?.card_count
                    }
                })
            }

            res = await agent.createCarouselTemplateGroups.post(payload);
        } else {
            const payload: updateCarouselTemplateGroupPayload = {
                carousel_template_group_id: selectedTemplateGroup?.carousel_template_group_id,
                max_card_count: Number(carouselTemplateGroup?.max_card_count),
                carousel_template_group_name: carouselTemplateGroup?.carousel_template_group_name,
                meta_integration_whatsapp_id: integrationDetails?.meta_integration_whatsapp_id ?? Number(id),
                whatsapp_template_ids: carouselTemplateGroup?.templates?.map((template) => {
                    return {
                        wa_carousel_template_group_mapping_id: selectedTemplateGroup?.templates?.find((temp) => temp?.card_count === template?.card_count)?.wa_carousel_template_group_mapping_id ?? '',
                        whatsapp_template_id: template?.whatsapp_template_id,
                        card_count: template?.card_count
                    }
                }),
            }
            res = await agent.updateCarouselTemplateGroups.put(payload);
        }

        if (!(res.status)) {
            handleError(res);
        } else {
            const successMessage = selectedTemplateGroup ? 'Carousel Template Group Updated Successfully' : 'Carousel Template Group Created Successfully';
            showSuccess(successMessage)
            getCarouselTemplateGroupsApi(integrationDetails?.meta_integration_whatsapp_id ?? Number(id));
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        onClickOfCancel();
    }

    const getOtionsOfTemplateDropdown = (cardCount: number) => {
        return carouselTemplateList?.filter((template) => template?.carousel_template_card_count === cardCount) ?? [];
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={contactStyles.popupTitleTypography}>
                                {getPopupTitle()}
                            </Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} />

                        <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`} sx={{ maxHeight: `${innerHeight}px !important` }}>
                            <Grid container  className={` ${contactStyles.popupBodyGridContainer}`} gap={2}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>
                                                Carousel Template Group Name <Required />
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                value={getFieldValues({type: 'templateGroupName'})}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChangeOfFields({ type: 'templateGroupName', value: e.target.value })}
                                                placeholder='Enter Carousel Template Group Name'
                                                className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>
                                                Maximum Card Count <Required />
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                value={getFieldValues({type: 'maxCardCount'})}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                                    const value = e.target.value;
                                                    if (value === '') {
                                                        onChangeOfFields({ type: 'maxCardCount', value: '' });
                                                        return;
                                                    }
                                                    if (value.includes('.')) return;
                                                    const parsedInt = parseInt(value, 10);
                                                    if (!isNaN(parsedInt) && parsedInt >= 2 && parsedInt <= 10) {
                                                        onChangeOfFields({ type: 'maxCardCount', value: parsedInt });
                                                    }
                                                }}
                                                placeholder='Enter Maximum Card Count (2-10)'
                                                type='number'
                                                inputProps={{ min: 2, max: 10, step: 1 }}
                                                className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Grid container direction={'column'}>
                                                <Grid item xs={12}>
                                                    <Grid container className={`${globalStyles.displayFlex}`} gap={1}>
                                                        <Typography className={contactStyles.popupFieldTypography}>
                                                            Carousel Template <Required />
                                                        </Typography>
                                                        <GlobalTooltip
                                                            placement='top'
                                                            arrow
                                                            title='Fetch latest carousel templates'
                                                        >
                                                            <Grid item onClick={() => getWhatsAppCarouselTemplateListApi()} className={globalStyles.displayFlex}>
                                                                <RefreshIcon className={`${globalStyles.primaryColor} ${globalStyles.clickable}`} />
                                                            </Grid>
                                                        </GlobalTooltip>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography className={style.templateSelectionNote}>
                                                        Select one template for each card count.
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>
                                                Select Template with
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {Array.from({ length: Math.max(0, Number(getFieldValues({type: 'maxCardCount'})) - 1)})?.map((_, ind) => {
                                                const cardCount = ind + 2;
                                                return (
                                                    <Grid key={ind} container flexWrap={"nowrap"} alignItems={"center"} className={style.mappingFieldsContainer}>
                                                        <Grid item xs={6} className={style.mappingCardCountGrid}>
                                                            <Typography className={style.mappingCardCountTitle}>
                                                                {`${cardCount} Cards`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Autocomplete
                                                                options={getOtionsOfTemplateDropdown(cardCount)}
                                                                value={(getFieldValues({type: 'templates', cardCount: cardCount}) as getTemplateDetails | null)}
                                                                getOptionLabel={(option) => `${option?.whatsapp_template_data?.[0]?.whatsapp_template_name}` || ''}
                                                                renderInput={(params) => <TextField {...params} placeholder="Select Template" />}
                                                                className={`${globalStyles.autocompleteParaphrasing} ${style.templateDropdown}`}
                                                                onChange={(e, value) => { onChangeOfFields({ type: 'templates', value: value, cardCount: cardCount}) }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                );
                                            }) }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid item>
                            <Grid container className={`${globalStyles.displayFlex} ${globalStyles.justifyCenter} ${style.popupBtnGroup}`} gap={"12px"}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => onClickOfCancel()}
                                    >
                                    </GlobalButton>
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={selectedTemplateGroup ? "Save" : "Create"}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        disabled={checkDisableCreateBtn()}
                                        onClick={() => onClickOfCreateBtn()}
                                    >
                                    </GlobalButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateTemplateGroupPopup
